import React from "react";
import styled from 'styled-components'
import {Link as LinkS} from 'react-scroll'
import {Link as LinkR} from 'react-router-dom'
import {FaTimes} from 'react-icons/fa'

export const SidebarContainer = styled.aside`
    position: fixed;
    z-index:1001;
    width:100%;
    height:auto;
    bottom:0;
    color:#1D1D1F;
    background:#fff;
    display: block;
    align-items: top;
    user-select: none;
    left:0;
    right:0;
    top:0;
    transition: 0.3s ease-in-out;
    opacity:${({isOpen}) =>(isOpen ? '100%' : '0')};
    visibility:${({isOpen}) =>(isOpen ? 'visible': "hidden")};
`;

export const CloseIcon = styled(FaTimes) `
    color: #000;
`;


export const Icon = styled.div`
    position: absolute;
    top: 1.2rem;
    left: 0;
    color: #000;
    right:1.5rem
    background:transparent;
    font-size: 17px;
    transform: translate(100%, 0%);
    cursor:pointer;
    outline:none;
`;

export const HomeIcon = styled.div`
    position: absolute;
    top: 1.2rem;
    left: 0;
    background:transparent;
    font-size: 17px;
    transform: translate(100%, 100%);
    cursor:pointer;
    outline:none;
`;

export const SidebarWrapper = styled.div`
color:#fff;
align-items: center;
justify-content: center;
width:100%;
`;


export const SidebarMenu = styled.ul`
    display:list;
    text-align: center;
    padding:45px 40px 8px;
    margin:0 auto;
`;

export const SidebarDivider = styled.div`
    background:#8c8c8c;
    width:100%;
    height:1px;
`;

export const SidebarLink = styled(LinkR)`
    display:flex;
    align-items:center;
    font-size:17px;
    letter-spacing: -.022em;
    line-height: 1.23536;
    padding:20px 1px 20px;
        font-weight: 400;
    text-decoration:none;
    list-style:none;
    transition:0.2s ease-in-out;
    color:#000;
    cursor:pointer;
`;

